import { Component, EventEmitter, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { User } from "src/app/core/user/user";
import { UserService } from "src/app/core/user/user.service";
import { Coletor } from "../coletor/coletor";
import { Doador } from "../doador/doador";
import { TecidoList } from "../tecidos-captados/tecido";

@Component({
  selector: "app-pdf-ficha-page",
  templateUrl: "./pdf-ficha-page.component.html",
  styleUrls: ["./pdf-ficha-page.component.css"],
})
export class PdfFichaPageComponent implements OnInit {
  doador: Doador;
  coletor: Coletor;
  fichaValida: boolean;
  listaTecidosCapatados: TecidoList;
  tecidosCaptadosNomes: string[] = [];
  tecidosCaptadosSitios: string[] = [];
  dataNascimentoDoador: string;
  dataExamesSanguineos: string;
  dataColeta: string;
  responsavelColeta: string;
  qual: boolean = false;
  emitter: EventEmitter<void> = new EventEmitter();
  user$: Observable<User>;

  constructor(private userService: UserService) {
    this.user$ = this.userService.getUser();
  }

  ngOnInit(): void {
    this.datas();
    this.userSubscribe();
    console.log(this.coletor);
    console.log(this.doador);
  }

  ngAfterViewInit(): void {
    this.emitter.emit();
  }

  dataFormatada(data) {
    if (data) {
      let dataNascimento = data;
      let dataN = dataNascimento.split("-");
      let dataA = dataN[0];
      let dataM = dataN[1];
      let dataD = dataN[2];
      let dataNFormatada = `${dataD}/${dataM}/${dataA}`;
      return dataNFormatada;
    }
    return "";
  }

  datas() {
    this.dataNascimentoDoador = this.dataFormatada(this.doador.dataNascimento);
    this.dataColeta = this.dataFormatada(this.coletor.dataColeta);
    this.dataExamesSanguineos = this.dataFormatada(
      this.coletor.dataExamesSanguineos
    );
  }

  sexoFeminino(feminino): string {
    let sexo;
    if (feminino === "Feminino") {
      return (sexo = "X");
    }
    return (sexo = " ");
  }

  sexoMasculino(masculino): string {
    let sexo;
    if (masculino === "Masculino") {
      return (sexo = "X");
    }
    return (sexo = " ");
  }

  sexoOutro(outro): string {
    let sexo;
    if (outro === "Outro") {
      return (sexo = "X");
    }
    return (sexo = " ");
  }

  opcaoSim(opcaoS): string {
    let op;
    if (!opcaoS) return;

    if (opcaoS === "sim") {
      this.qual = true;
      return (op = "X");
    }
    return;
  }

  opcaoNao(opcaoN): string {
    let op;
    if (!opcaoN) return;

    if (opcaoN === "não") {
      this.qual = false;
      return (op = "X");
    }
    return;
  }

  check(marcar): string {
    let op;
    if (!marcar) return;
    return (op = "X");
  }

  exameSim(exame): string {
    let op;
    if (!exame) return;

    if (exame === "sim") {
      this.qual = true;
      return (op = "X");
    }
    return;
  }

  exameNao(exame): string {
    let op;
    if (!exame) return;

    if (exame === "não") {
      this.qual = false;
      return (op = "X");
    }
    return;
  }

  rhPositivo(rh): string {
    let op;
    if (!rh) return;
    if (rh === "Positivo") {
      return (op = "X");
    }
    return;
  }

  rhNegativo(rh): string {
    let op;
    if (!rh) return;
    if (rh === "Negativo") {
      return (op = "X");
    }
    return;
  }

  userSubscribe() {
    this.user$.subscribe((user) => {
      this.responsavelColeta = user.sub;
    });
  }

  tecidosNome(): string {
    for (let i in this.listaTecidosCapatados) {
      this.tecidosCaptadosNomes.push(this.listaTecidosCapatados[i].nome);
    }

    let tecidos = this.tecidosCaptadosNomes.join(", ");
    return tecidos;
  }

  tecidosSitio(): string {
    for (let i in this.listaTecidosCapatados) {
      this.tecidosCaptadosSitios.push(this.listaTecidosCapatados[i].sitio);
    }

    let tecidos = this.tecidosCaptadosSitios.join(", ");
    return tecidos;
  }

  doecasText(): string {
    const doencas = [
      this.coletor.anemia,
      this.coletor.doencaNoFigado,
      this.coletor.hepatite_b,
      this.coletor.chikungunya,
      this.coletor.febreReumatica,
      this.coletor.hepatite_c,
      this.coletor.covid,
      this.coletor.febre_sem_diagnostico,
      this.coletor.leucemia,
      this.coletor.dengue,
      this.coletor.hemorragias,
      this.coletor.tuberculose,
      this.coletor.diabetes,
      this.coletor.hemofilia,
      this.coletor.zika,
      this.coletor.doencaNosRins,
      this.coletor.hepatite_a,
      this.coletor.outraDoencaSintomaCheck,
      this.coletor.outraDoencaSintoma,
      this.coletor.naoDoencaSintomaCheck,
    ];

    let string = doencas.map((res) => (res ? `${res}, ` : "")).join("");
    return string.slice(0, -2);
  }
}
